export default __webpack_public_path__ + "static/media/search.d0b310ab.svg";